import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import textFinnish from '../../translations/finnish.json';
import { translations as componentLibraryTranslations } from '@ailex/react-components';

/**
 * Setup application translations. Call this once on the top level
 * @returns initialized i18n
 */
export default function setup() {
  // eslint-disable-next-line import-x/no-named-as-default-member
  i18next.use(initReactI18next).init({
    lng: 'fi',
    fallbackLng: 'fi',
    resources: {
      ['fi']: {
        translation: {
          ...textFinnish,
          ...componentLibraryTranslations.fi,
        },
      },
    },
  });

  return i18next;
}
